import { Text } from '@beef/ui-kit';
import React from 'react';

import { formatPrice } from 'utils/formatting';

const DeviceTypeLabelByType = {
  'CELL PHONE': 'смартфон',
  TABLETS: 'планшет',
};

export const BannerText = React.memo(({ maxPrice, deviceType, deviceBrand, deviceModel }) => (
  <Text size="size5-m" color="white">
    <span style={{ fontWeight: 'bold' }}>{formatPrice(maxPrice)} ₽</span>{' '}
    {`скидка по Трейд-ин за ${DeviceTypeLabelByType[deviceType]} ${deviceBrand} ${deviceModel}`}
  </Text>
));
